import { type FC } from 'react'

import { F0Box, F0Text } from '@factorialco/f0-react'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)

export interface DeviceAttribute {
  id: string
  name: string
  value: string
}

export interface DeviceSpecificationsProps {
  attributes: DeviceAttribute[]
}

export const DeviceSpecifications: FC<DeviceSpecificationsProps> = ({ attributes }) => {
  if (!attributes || attributes.length === 0) {
    return null
  }

  const shouldScroll = attributes.length > 4
  const scrollStyle = shouldScroll
    ? { maxHeight: '150px', overflowY: 'auto' as const, paddingRight: '8px' }
    : undefined

  return (
    <F0Box display="flex" flexDirection="column" gap="xl" paddingY="md">
      <SectionHeader
        title={i18n.t('it_management.device_catalog.detail.technical_specifications')}
        description=""
      />

      <div
        data-testid="device-specifications-grid"
        className="grid grid-cols-2 gap-6 gap-x-12"
        style={scrollStyle}
      >
        {attributes.map((attribute) => (
          <F0Box key={attribute.id} display="flex" flexDirection="column" gap="sm">
            <F0Text variant="description" content={capitalize(attribute.name)} />
            <F0Text variant="body" content={attribute.value} />
          </F0Box>
        ))}
      </div>
    </F0Box>
  )
}
